import { render, staticRenderFns } from "./SpecificSearch.vue?vue&type=template&id=54d19433&scoped=true"
import script from "./SpecificSearch.vue?vue&type=script&lang=js"
export * from "./SpecificSearch.vue?vue&type=script&lang=js"
import style0 from "./SpecificSearch.vue?vue&type=style&index=0&id=54d19433&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d19433",
  null
  
)

export default component.exports